export default "__VITE_PUBLIC_ASSET__97656cf8__"